import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { User } from 'src/app/shared/models/user.model';
import { environment } from 'src/environments/environment';


@Injectable()
export class LoginClientService {
    /**
     * 
     * @param httpRequest 
     */
    constructor(private http: HttpClient){

    }

    /**
     * 
     * @param user 
     */
    login(user: User){
        return this.http.post<any>(`${environment.url_api}/auth/login`,user);
    }

}